import React from 'react';
import { render } from 'react-dom';
import { Router, Switch } from 'react-router-dom';
import App from './src/App';
import { createBrowserHistory } from 'history';
export const history = createBrowserHistory();

render(
  <Router history={history}>
    <Switch>
      <App key={'app'} />
    </Switch>
  </Router>,
  document.getElementById('app')
);
